module.exports = __webpack_public_path__ + "img/18.8.TSS.260c7029.png";